import { APP_INITIALIZER, ErrorHandler, inject, NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from 'src/environments/environment';

/* MODULES */
import { AuthModule } from '@modules/auth/auth.module';
import { AppRoutingModule } from './app-routing.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';

/* COMPONENTS */
import { AppComponent } from './app.component';
import { AppService } from '@shared/services/core/app.service';
import { SnackbarService } from '@shared/services/core/snackbar.service';
import { SpinnerService } from '@core/components/spinner/spinner.service';

/* INTERCEPTORS */
import { AllInterceptorProviders } from '@core/interceptors';

import { CookieModule } from 'ngx-cookie';
import { DatePipe } from '@angular/common';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ErrorService } from '@shared/services/core/error.service';
import { AppInitializationWithUriPage } from './pages/auth/app-initialization-with-uri.page';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ListViewModule } from "@progress/kendo-angular-listview";
import 'hammerjs';
import { SharedModule } from './modules/shared/shared.module';
import { PagerModule } from '@progress/kendo-angular-pager';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { PasswordPolicyComponent } from './pages/auth/password-policy/password-policy.component';
import { LinkExpireComponent } from './pages/error/link-expire/link-expire.component';




export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    AppInitializationWithUriPage,
    PasswordPolicyComponent,
    LinkExpireComponent
  ],
  imports: [
    AppRoutingModule,
    AuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    ListViewModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CookieModule.withOptions(),
    MatSnackBarModule,
    IndicatorsModule,
    ChartsModule,
    ButtonsModule,
    LayoutModule,
    SchedulerModule,
    PagerModule,
    BackButtonDisableModule.forRoot()
  ],
  providers: [
    AllInterceptorProviders, {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const appService = inject(AppService);
        return () => new Promise((resolve) => {
          let configs!: unknown;
          let appSettings!: unknown;
          // loading file based on environment.· · · · · 
          configs = require(`../assets/configs/config.${environment.name}.json`);
          appSettings = require(`../assets/configs/appSettings.config.${environment.name}.json`);
          appService.setAppConfigs(JSON.stringify(configs));
          appService.setAppSettings(JSON.stringify(appSettings));
          resolve(true);
        });
      }, multi: true
    }, {
      provide: ErrorHandler,
      useClass: ErrorService
    },
    DatePipe,
    SnackbarService,
    SpinnerService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }